import styled from 'styled-components';
import { rem } from 'polished';
var StyleOptionsButtonInner = styled.span.withConfig({
  displayName: "StyleOptionsButtonInner",
  componentId: "sv92lv-0"
})(["min-width:", ";"], rem(16));
export default StyleOptionsButtonInner;